import { useOrganization } from "@clerk/clerk-react";
import type { UseAuthReturn, UseUserReturn } from "@clerk/types";
import { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";

import { GetLocationsItem } from "@/shared/api/generated/schemas";
import { AppAbility } from "@/shared/providers/casl-provider/authorization/rules";

interface RouterContext {
  auth: UseAuthReturn;
  user: UseUserReturn;
  organization: ReturnType<typeof useOrganization>;
  locations: GetLocationsItem[] | undefined;
  queryClient: QueryClient;
  ability: AppAbility;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: Root,
});

function Root() {
  return (
    <>
      <Outlet />
      {import.meta.env.DEV && <TanStackRouterDevtools />}
    </>
  );
}
